// Schönecke: Preisinfo-Block beim Wechsel der Gewichtsklasse mit dem neu gerenderten Block ersetzen
// (gleiches Muster wie product-price.js).
import { StandardEvents } from '@shopify/events';

class SchoeneckePreisinfo extends HTMLElement {
  connectedCallback() {
    this.ziel = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    this.ziel?.addEventListener(StandardEvents.productSelect, this.#aktualisieren);
  }

  disconnectedCallback() {
    this.ziel?.removeEventListener(StandardEvents.productSelect, this.#aktualisieren);
  }

  #aktualisieren = (event) => {
    event.promise
      ?.then(({ detail }) => {
        const neu = detail?.html?.querySelector(`schoenecke-preisinfo[data-block-id="${this.dataset.blockId}"]`);
        if (neu) this.replaceWith(neu);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[schoenecke-preisinfo]', error);
      });
  };
}

if (!customElements.get('schoenecke-preisinfo')) customElements.define('schoenecke-preisinfo', SchoeneckePreisinfo);
